import React, { memo } from 'react';

import { StyledLandingHeader } from './styles';
import { HeroSubtitle, HeroTitle } from '../../../theme/theme-provider';
import { bemClassName } from '../../../utils/bem';
import { GradientButton } from '../../molecules/gradient-button';

const b = bemClassName('landing-header');

const LandingHeader = ({ backgroundImage, mobileBackgroundImage, variant, onCtaClick }) => {
  return (
    <StyledLandingHeader
      $backgroundImage={backgroundImage}
      $mobileBackgroundImage={mobileBackgroundImage}
      $variant={variant}
    >
      <div className={b()}>
        <div className={b('bg')} />
        <div className={b('content')}>
          <div className={b('hero')}>
            <div className={b('hero-title')}>
              <HeroTitle>Your Personal Health &amp; Fitness Platform</HeroTitle>
            </div>
            <div className={b('hero-subtitle')}>
              <HeroSubtitle>
                Recipes, workouts, health tracking, and AI-powered insights to help you reach your goals.
              </HeroSubtitle>
            </div>
            <div className={b('hero-cta')}>
              <GradientButton onClick={onCtaClick}>GET STARTED FREE</GradientButton>
            </div>
          </div>
        </div>
      </div>
    </StyledLandingHeader>
  );
};

export default memo(LandingHeader);
